<template>
	<div>
		<div v-if="showComment()" class="flex min-w-0">
			<div v-if="level > 0 && level <= maxLevels" class="w-6 shrink-0 flex justify-start">
				<div class="ml-2 h-full relative"
					 :class="{'border-r border-gray-200 dark:border-slate-700': !isLast }">
					<div
						class="absolute left-0 top-0 w-4 h-9 rounded-bl-xl border-b border-l border-gray-200 dark:border-slate-700"></div>
				</div>
			</div>
			<div class="flex-1 min-w-0">
				<div :class="{ 'py-2': !short } ">
					<div v-if="commentModel.is_blacklisted" class="text-gray-500 text-sm py-2">
						Комментарий скрыт
					</div>
					<div v-else>
						<div ref="comment" class="comment group"
							 @mouseenter="markAsViewed"
							 :class="{
                                'comment-short': short && !pinned,
                                'comment-hovered': hovered,
                                'comment-pinned': commentModel.is_pinned,
                                'comment-highlighted': needToHighlight,
                            }">
							<div v-if="!short" :id="'comment-' + commentModel.id"></div>
							<div class="flex space-x-6 justify-between items-start mb-3 min-w-0">
								<div v-if="!commentModel.is_deleted" class="flex space-x-2 items-center flex-1 min-w-0">
									<a :href="commentModel.author.url" class="block w-8 h-8 shrink-0">
										<avatar :ava="commentModel.author.ava" class="w-8 h-8"></avatar>
									</a>
									<div class="flex-1 min-w-0">
										<div class="leading-tight flex items-center space-x-4 min-w-0">
											<a :href="commentModel.author.url"
											   class="text-black dark:text-white flex items-center space-x-2 min-w-0">
												<div class="font-medium truncate">{{ commentModel.author.name }}</div>
												<svg-icon
													icon="check-circle-fill"
													v-if="commentModel.author.is_verified"
													class="w-3 h-3 text-blue-500 shrink-0">
												</svg-icon>
												<svg-icon v-if="commentModel.author.is_bot" icon="robot" set="local"
														  class="w-4 h-4 text-orange shrink-0">
												</svg-icon>

												<svg-icon v-if="commentModel.is_pinned"
														  icon="pin-angle-fill"
														  class="w-3 h-3 text-orange shrink-0"
														  title="Комментарий закреплен"
												></svg-icon>

												<div v-if="commentModel.can_ban && commentModel.author.ban"
													 class="bg-red-500 text-white rounded-xl leading-none text-xs py-1 px-2">
													<div v-if="commentModel.author.ban.permanent">
														Бан пермач
													</div>
													<div v-else>
														Бан до
														<smartdate class="inline-block font-bold"
																   :date="commentModel.author.ban.banned_until"
																   :ignore-future="1" :direct="true"></smartdate>
													</div>
												</div>
											</a>
											<div v-if="commentModel.parent_comment_id > 0"
												 @mouseenter="$emit('hover:on')"
												 @mouseleave="$emit('hover:off')"
												 @click="$emit('scroll', commentModel.id)"
												 class="md:hidden md:group-hover:block text-gray-500 cursor-pointer">
												<svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="16"
													 height="16"
													 fill="currentColor" viewBox="0 0 16 16">
													<path fill-rule="evenodd"
														  d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/>
												</svg>
											</div>
											<div v-if="prevCommentId"
												 @click="scrollBack"
												 class="md:hidden md:group-hover:block text-gray-500 cursor-pointer">
												<svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="16"
													 height="16"
													 fill="currentColor" viewBox="0 0 16 16">
													<path fill-rule="evenodd"
														  d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
												</svg>
											</div>
										</div>
										<a :href="commentModel.url"
										   class="flex space-x-3 items-center text-gray-400 text-xs">
											<smartdate :date="commentModel.date" :ignore-future="true"></smartdate>

											<svg v-if="commentModel.is_edited" title="Комментарий был отредактирован"
												 class="text-gray-500 dark:text-gray-300 w-2 h-2"
												 xmlns="http://www.w3.org/2000/svg"
												 width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
												<path
													d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
											</svg>

											<div v-if="commentModel.user_id === userid"
												 class="text-blue-600 dark:text-blue-300">
												Автор
											</div>
										</a>
									</div>
								</div>

								<div class="hidden md:block" v-if="!commentModel.is_deleted">
									<rate v-if="!short && !commentModel.disable_rating" class="text-sm" type="comment"
										  :id="commentModel.id"
										  :can-vote="user.check()"
										  :voted="commentModel.voted"
										  :rate="commentModel.rate"></rate>

									<rating v-if="rate" :rate="commentModel.rate"></rating>
								</div>
							</div>

							<div
								:class="{'text-gray-500 dark:text-slate-500': commentModel.is_deleted || commentModel.is_self_deleted}">
								<div v-if="commentModel.is_self_deleted">
									Комментарий удален автором
								</div>
								<div v-else-if="!short || pinned" v-html="commentModel.body"
									 class="body-container overflow-hidden"></div>
								<div v-else v-html="commentModel.body_short"
									 class="body-container overflow-hidden"></div>
								<div v-if="commentModel.is_deleted && commentModel.can_ban"
									 class="text-xs mt-2 cursor-pointer" @click="showDeleted">
									Показать
								</div>
							</div>
							<div
								v-if="commentModel.images && commentModel.images.length && !commentModel.is_deleted && !commentModel.is_self_deleted"
								class="flex items-center space-x-2 mt-2">
								<comment-gallery
									:images="commentModel.images"
									:id="commentModel.id"
									:compact="short && !pinned"
									@mediaLoaded="reportLoaded"
								></comment-gallery>
							</div>

							<a @click.prevent="navigateToComment" v-if="short && !pinned" :href="commentModel.url"
							   class="absolute inset-0 z-30"></a>
						</div>

						<div v-if="short && post" class="mt-2 px-2 max-w-full truncate">
							<a :href="post.url" class="font-medium text-black dark:text-white"
							   :title="post.header ? post.header : 'Запись без заголовка'">
								{{ post.header ? post.header : 'Запись без заголовка' }}
							</a>
						</div>

						<div v-if="!short && !commentModel.is_deleted" class="px-2">
							<div class="flex space-x-4 justify-between items-center">
								<div class="flex space-x-4 items-center">
									<div v-if="user.check()"
										 class="text-sm text-gray-500 dark:text-gray-300 cursor-pointer hover:text-blue-500"
										 @click="$emit('toggleReply',commentModel.id)">
										Ответить
									</div>

									<comment-options
										v-if="user.check()"
										:comment="commentModel"
										@toggleEdit="toggleEditMode"
										@commentUpdated="updateComment"
										@branchDeleted="deleteBranch"
									></comment-options>
								</div>

								<div class="block md:hidden" v-if="!commentModel.is_deleted">
									<rate
										v-if="!short && !commentModel.disable_rating" class="text-sm" type="comment"
										:can-vote="user.check()"
										:id="commentModel.id"
										:voted="commentModel.voted"
										:rate="commentModel.rate"></rate>

									<rating v-if="rate" :rate="commentModel.rate"></rating>
								</div>
							</div>
							<div v-if="store.data === commentModel.id">
								<comment-form @commentAdded="$emit('commentAdded', $event)"
											  :focus="true"
											  :postid="postid"
											  :reply="true"
											  :parent_id="commentModel.id"
											  class="mt-1  max-w-xl"></comment-form>
							</div>
							<div v-if="editMode">
								<comment-form
									@commentUpdated="updateComment($event)"
									@closeForm="editMode = false"
									:comment="commentModel"
									:focus="true"
									:postid="postid"
									class="mt-1  max-w-xl"></comment-form>
							</div>
						</div>
					</div>

				</div>

				<div v-if="!short && !branchDeleted">
					<div v-for="(child, index) in comments[commentModel.id]"
						 :key="commentModel.id">
						<comment class="flex-1"
								 :comment="child"
								 :comments="comments"
								 :index="index"
								 :level="level+1"
								 :postid="postid"
								 :userid="userid"
								 @toggleReply="$emit('toggleReply',$event)"
								 @closeForm="$emit('closeForm')"
								 @commentAdded="$emit('commentAdded', $event)"
								 @hover:on="hovered = true"
								 @hover:off="hovered = false"
								 @scroll="scrollToParent($event)"
								 @mediaLoaded="reportLoaded"
								 @commentUpdated="updateComment"
						></comment>
					</div>
				</div>
			</div>

			<complain-dialog ref="complainDialog"></complain-dialog>
		</div>
	</div>
</template>
<script>
import {notify} from "@kyvg/vue3-notification";
import UploadImage from "../partials/uploadImage";
import CommentForm from "../post/CommentForm";
import Client from "../../js/modules/Client";
import ComplainDialog from "../partials/ComplainDialog";
import CommentOptions from "./CommentOptions";
import CommentGallery from "./CommentGallery";
import User from "../../js/modules/User";
import Avatar from "../partials/Avatar.vue";
import {CommentStore} from "../../js/stores/CommentStore";

export default {
	components: {Avatar, CommentGallery, UploadImage, CommentForm, ComplainDialog, CommentOptions},
	emits: ['commentUpdated'],
	props: {
		rate: {
			type: Boolean,
			default: false,
		},
		hoverBranch: {
			type: Boolean,
			default: false,
		},
		index: {
			type: Number,
			default: 0,
		},
		short: {
			type: Number,
			default: 0,
		},
		pinned: {
			type: Number,
			default: 0,
		},
		postid: {
			type: Number,
			default: 0,
		},
		userid: {
			type: Number,
			default: 0,
		},
		level: {
			type: Number,
			default: 0,
		},
		post: {
			type: Object,
			default: null,
		},
		comment: {
			type: Object,
			default: null,
		},
		comments: {
			type: Object,
			default: {},
		},
		isNew: {
			type: Boolean,
			default: false,
		},
		highlight: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			commentModel: this.comment,
			string: '',
			form: {
				body: '',
				image: null,
				parent_id: 0,
			},
			maxLevels: this.getMaxLevels(),
			sending: false,
			optionsOpened: false,
			editMode: false,
			hovered: false,
			prevCommentId: null,
			branchDeleted: false,
			user: new User(),
			store: new CommentStore(),
			markedAsViewed: false,
		};
	},
	updated() {
		this.commentModel = this.comment;
	},
	methods: {
		toggleEditMode() {
			this.editMode = true;
		},
		processKey(event) {
			if ((event.metaKey || event.ctrlKey) && event.keyCode === 13) {
				this.send();
			}
		},
		send() {
			let hasComment = this.string && this.string.length;
			let isNotEmpty = hasComment || this.form.image;

			if (isNotEmpty && !this.sending) {
				this.form.parent_id = this.commentModel.id;
				this.form.body = this.string;
				this.sending = true;
				Client.post('/api/v1.1/posts/' + this.postid + '/comments', this.form)
					.then(response => {
						if (!this.comments[this.commentModel.id]) {
							this.comments[this.commentModel.id] = [];
						}
						this.comments[this.commentModel.id].push(response.data.data);
						this.form.body = '';
						this.form.image = null;
						this.string = '';
						this.sending = false;

						this.$emit('closeForm')
					})
					.catch(error => {
						notify({
							type: 'error',
							text: 'Ошибка. Жаль',
						});
						this.sending = false;
					});
			}
		},
		scrollToParent(prev) {
			let comment = this.$refs.comment;
			this.prevCommentId = prev;
			window.scrollTo(0, comment.getBoundingClientRect().top + window.scrollY - 80);

			comment.classList.add('target');
			setTimeout(() => {
				comment.classList.remove('target');
			}, 2000);
		},
		scrollBack() {
			let prevComment = document.querySelector('#comment-' + this.prevCommentId);
			window.scrollTo(0, prevComment.getBoundingClientRect().top + window.scrollY - 80);
			this.prevCommentId = null;
		},
		navigateToComment(event) {
			let a = event.target;
			let anchor = '#comment-' + this.commentModel.id;
			const el = document.querySelector(anchor);
			if (el) {
				window.scrollTo(0, el.getBoundingClientRect().top + window.scrollY - 80);
				let container = el.closest('.comment');
				if (container) {
					container.classList.add('target');
				}
				setTimeout(() => {
					el.closest('.comment').classList.remove('target');
				}, 2000);
			} else {
				window.location.href = a.href;
			}
		},
		updateComment(comment) {
			this.editMode = false;
			this.$emit('commentUpdated', comment);
		},
		deleteBranch() {
			this.branchDeleted = true;
		},
		getMaxLevels() {
			let desktop = window.screen.width > 800;
			return desktop ? 5 : 2;
		},
		showDeleted() {
			Client.get('/api/v1.1/posts/' + this.postid + '/comments/' + this.comment.id)
				.then(response => {
					this.$emit('commentUpdated', response.data.data);
				})
				.catch(error => {
					notify({
						type: 'error',
						text: 'Ошибка. Жаль',
					});
					this.sending = false;
				});
		},
		showComment() {
			return this.commentModel.can_delete || this.hasNonDeletedChilds(this.commentModel);
		},
		hasNonDeletedChilds(comment) {
			let hasNonDeletedChilds = false;

			if (!comment.is_deleted) {
				return true;
			}

			let childs = this.comments[comment.id];

			if (childs && childs.length) {
				childs.forEach((child) => {
					if (this.hasNonDeletedChilds(child)) {
						hasNonDeletedChilds = true;
					}
				});
			}

			return hasNonDeletedChilds;
		},
		reportLoaded() {
			this.$emit('mediaLoaded');
		},
		markAsViewed() {
			this.markedAsViewed = true;
		},
	},
	computed: {
		isLast() {
			let index = this.index + 1;
			return this.comments[this.commentModel.parent_comment_id].length === index;
		},
		needToHighlight() {
			if (this.highlight) {
				return true;
			}

			if (this.markedAsViewed) {
				return false;
			}

			return this.isNew;
		}
	}
}
</script>
